<h3>{{title}}</h3>

<mat-list>
  <mat-list-item class="petition" *ngFor="let petition of petitions">
    <span class="text">
      {{petition.text}}
    </span>
    <span class="dateRange">
      {{petition | dateRange}}
    </span>
    <button mat-icon-button aria-label="Edit petition" (click)="onEditPetition(petition)">
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button aria-label="Delete petition" (click)="onDeletePetition(petition)">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-list-item>
</mat-list>